import moment from 'moment'
import axios from 'axios'

export default {
  hosts: {
    // url: 'https://xokekpch1h.execute-api.us-east-2.amazonaws.com/Production'
    url: 'https://0inqb0jf0b.execute-api.us-east-2.amazonaws.com/Dev'
    //url: 'http://3.16.255.1:9090/'
    //url: 'http://3.140.32.151:9090/'
  },
  
  getAxios () {
    return axios.create({
      baseURL: this.hosts.url,
      timeout: 100000
    })
  },
  getPayableTypes (context) {
    const types = [
      {
        id: '2',
        label: 'Vendor'
      },
      {
        id: '9',
        label: 'Store'
      },
      {
        id: '11',
        label: 'Lawfirm'
      },
      {
        id: '6',
        label: 'Utility'
      }
    ]
    context.types = types
  },
  getMasscommunicationParentTypes (context) {
    const types = [
      {
        id: 'vendors',
        label: 'Vendor'
      },
      {
        id: 'prospects',
        label: 'Prospects'
      },
      {
        id: 'tenants',
        label: 'Tenants'
      }
    ]
    context.parentTypes = types
  },
  convertObjectToString (obj) {
    return JSON.stringify(obj)
  },
  getSnapPmsDateFromString (dateStr) {
    const momenta = moment.isMoment(dateStr)
    if (momenta) {
      const obj = { date: dateStr.date(), month: dateStr.month() + 1, year: dateStr.year() }
      return obj
    } else {
      const parts = dateStr.split('-')
      const obj = { date: parts[1], month: parts[0], year: parts[2] }
      return obj
    }
  }
}
